<div>
    <mat-horizontal-stepper linear #stepper>

        <mat-step [editable]="false">
            <ng-template matStepLabel>Confirm Free Order</ng-template>
            <h3>Order details</h3>
            <div class="order-table-container">
                <table>
                    <tr>
                        <th>Item</th>
                        <th>Personal Assistant</th>
                        <th>Email</th>
                        <th>Address</th>
                        <th>Price</th>
                    </tr>
                    <tr *ngFor="let user of users; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ user.paName }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.address }}</td>
                        <td>£0.00</td>
                    </tr>
                </table>
                <div class="total-price">
                    <span>Total cost: £{{price}}.00</span>
                </div>
                <div class="button-container">
                    <!-- <button mat-button matStepperPrevious>
                        <mat-icon>undo</mat-icon><span> Back</span>
                    </button> -->
                    <button (click)="takePayment()" mat-button matStepperNext>
                        <mat-icon>credit_card</mat-icon><span> Place free order now</span>
                    </button>
                </div>
            </div>
        </mat-step>
        <mat-step [editable]="false">
            <ng-template matStepLabel>Free order confirmation</ng-template>
            <div class="confirm-order-details" *ngIf="processing">
                <h2>Processing transaction... please do not leave this page</h2>
                <mat-spinner></mat-spinner>
            </div>
            <div class="confirm-order-details" *ngIf="isSuccess && !processing">
                <div>
                    <span><mat-icon>check_circle_outline</mat-icon></span>
                </div>
                <br/><br/><br/><br/>
                <div class="order-confirm-text">
                    Order confirmed - #{{orderDetails.transactionReference}}
                </div>
                <div class="order-msg">
                    Thank you for your order an email has been sent to {{users[0].email}} with confirmation details.
                    <!-- <br/><br/>
                    <h3>You will now be redirected back to the PA Network Scotland Website</h3> -->
                
                </div>
                
                
            </div>
            <div class="confirm-order-details" *ngIf="!isSuccess && !processing">
                <div>
                    <span><mat-icon style="color: red;">cancel</mat-icon></span>
                </div>
                <div class="order-msg">
                    Purchase failed. Please try again later or contact our support team at info@panetworkscotland.org.uk.
                </div>                
            </div>
            <div>
                <!-- <button mat-button matStepperPrevious>Back</button>
                <button mat-button (click)="stepper.reset()">Reset</button> -->
            </div>
            <!-- <div class= "confirm-order-details">
                <a href="https://www.panetworkscotland.org.uk/">
                <img src="/assets/images/PANetworkReturnImage.png">
            </a>
            </div> -->
        </mat-step>
    </mat-horizontal-stepper>
</div>